import React, { useEffect, useState } from 'react';
import RippledLabelRadioButton from './RippledLabelRadioButton';
import { RUN_CONT, RUN_ONCE } from '../../../constants/constant';
import { withStyles } from '@material-ui/core/styles';
import { RadioGroup } from '@material-ui/core';
import reportSettingStyles from '../ReportSettings.style.js';
import { useSelector } from 'react-redux';
import { isCalFamily } from 'components/Preview/filter/FilterCondition';
import moment from 'moment';
const StyledRadioGroup = withStyles({
	root: {
		display: 'flex',
		padding: '8px 16px 8px 16px',
		'& span > div': {
			opacity: 0
		}
	}
})(RadioGroup);

const StyledRadioGroupComp = ({ btnSelected, width, handleBtnClick, isSmallScreen }) => {
	const [customTimeSelected, setCustomTimeSelected] = useState(false);
	const filterList = useSelector((state) => state.previewReducer.filterList);

	useEffect(() => {
		const isCalSelected = filterList.find((item) => isCalFamily(item) && item.field !== undefined);
		if (isCalSelected?.filter?.condition === 'Custom') {
			// Applies on Custom week & Custom date only
			// TODO: We need to handle the MTS as well
			// Check if the end date is greater than current timestamp (Which means in future, Then we can enable the Run continously button)
			let endDate;
			endDate = filterList.find((el) => el.dataType === 'date').filter?.value[1];
			endDate = moment(endDate);
			if (endDate > moment()) {
				setCustomTimeSelected(false);
			} else {
				setCustomTimeSelected(true);
			}
		}
	}, []);

	const classes = reportSettingStyles({ isSmallScreen });
	return (
		<StyledRadioGroup
			id="radio-group-once-vs-continuous"
			aria-label="once vs. continuous"
			name="run"
			role="radiogroup"
			value={btnSelected}
			row
			onChange={(e) => handleBtnClick(e)}
			className={classes.radioContainer}>
			<RippledLabelRadioButton
				btnSelected={btnSelected}
				width={width}
				value="once"
				label={RUN_ONCE}
				specialClasses="left"
				isSmallScreen={false}
			/>
			<RippledLabelRadioButton
				btnSelected={btnSelected}
				width={width}
				value="continuous"
				label={RUN_CONT}
				specialClasses="right"
				isSmallScreen={false}
				disabled={customTimeSelected}
			/>
		</StyledRadioGroup>
	);
};

export default StyledRadioGroupComp;
